import React, { useState } from 'react';

import { useHistory } from 'react-router';
import { Link } from '~/lib/react-router-dom';

import { Alert, Box, Button, Stack } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';

import GridPagination from '~/components/Common/Elements/GridPagination';
import Spinner from '~/components/Common/Spinner';
import { CruiseBundle } from '~/components/Cruises/pages/Bundles/types';

import { RECORDS_PER_PAGE, useGetBundles } from '~/hooks/apis/cruises/useGetBundles';

import { formatDateShort } from '~/services/TimeService';

export default function BundleList() {
  const [page, setPage] = useState(1);
  const history = useHistory();

  const { data, isLoading, error } = useGetBundles(page);

  const bundles = data?.result ?? [];
  const total = data?.total ?? 0;

  const columns: Array<GridColDef> = [
    {
      field: 'name',
      headerName: 'Name',
      sortable: false,
      disableColumnMenu: true,
      flex: 2,
      display: 'flex',
    },
    {
      field: 'startDate',
      headerName: 'Start Date',
      sortable: false,
      disableColumnMenu: true,
      flex: 2,
      renderCell: (params) => formatDateShort(params.value),
      display: 'flex',
    },
    {
      field: 'endDate',
      headerName: 'End Date',
      sortable: false,
      disableColumnMenu: true,
      flex: 2,
      renderCell: (params) => formatDateShort(params.value),
      display: 'flex',
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 120,
      sortable: false,
      renderCell: (params) => (
        <Button
          variant="text"
          size="small"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            history.push(`/cruises/bundles/edit/${params.row.id}`);
          }}
        >
          Edit
        </Button>
      ),
      display: 'flex',
    },
  ];

  if (isLoading) {
    return <Spinner />;
  }

  if (error) {
    return <Alert severity="error">Error loading bundles: {error.message}</Alert>;
  }

  return (
    <Box mt={1}>
      <Stack mt={3} width="100%" direction="row" justifyContent="flex-end">
        <Button component={Link} to="/cruises/bundles/create" variant="contained" color="primary" size="small">
          Add New Bundle
        </Button>
      </Stack>

      <DataGrid
        loading={isLoading}
        rows={bundles}
        columns={columns}
        pagination
        paginationModel={{ page: page - 1, pageSize: RECORDS_PER_PAGE }}
        pageSizeOptions={[15]}
        getRowId={(row: CruiseBundle) => row.id}
        paginationMode="server"
        rowCount={total}
        onPaginationModelChange={({ page }) => setPage(page + 1)}
        slots={{ pagination: GridPagination }}
        autoHeight
      />
    </Box>
  );
}
